import { render, staticRenderFns } from "./zxmy.vue?vue&type=template&id=71b499e7&scoped=true&"
import script from "./zxmy.vue?vue&type=script&lang=js&"
export * from "./zxmy.vue?vue&type=script&lang=js&"
import style0 from "./zxmy.vue?vue&type=style&index=0&id=71b499e7&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b499e7",
  null
  
)

export default component.exports